import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor() {}

  Message: string = '';
  showMessage: boolean = false;
  timer?: any;
  newMessage(newMessage: string) {
    this.Message = newMessage;
    this.showMessage = true;

    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.showMessage = false;
    }, 5000);
  }
}
